import { loadStripe, type Stripe } from '@stripe/stripe-js';

const stripePromises = new Map<string, Promise<Stripe | null>>();

/**
 * Stripe's async loader can still hold the browser's load event open when it is
 * started during module evaluation. Wait for the first-party page load before
 * starting Stripe so unrelated routes never depend on Stripe's network path.
 */
export const loadStripeAfterPageLoad = (publishableKey: string): Promise<Stripe | null> | null => {
  if (!publishableKey) return null;

  const existing = stripePromises.get(publishableKey);
  if (existing) return existing;

  const promise =
    document.readyState === 'complete'
      ? loadStripe(publishableKey)
      : new Promise<Stripe | null>((resolve, reject) => {
          window.addEventListener(
            'load',
            () => {
              loadStripe(publishableKey).then(resolve, reject);
            },
            { once: true },
          );
        });

  stripePromises.set(publishableKey, promise);
  return promise;
};
